import { BROKERBANS_REL, BROKERBANS_REL_MIX } from './types';
// eslint-disable-next-line import/prefer-default-export
export var setBrokerBansRelRedux = function (payload) { return ({
    type: BROKERBANS_REL,
    payload: payload,
}); };
export var setBrokerBanRedux = function (payload) { return ({
    type: BROKERBANS_REL_MIX,
    payload: payload,
}); };
